import React, { useState, useEffect } from 'react';

// Define the CSS animation in a style block
const bannerAnimationStyle = `
@keyframes scrollText {
  0% {
    transform: translateX(20%);
  }
  100% {
    transform: translateX(-100%);
  }
}
`;

interface MovingBannerProps {
  text: string;
  speed?: number;
  backgroundColor?: string;
  textColor?: string;
}

const MovingBanner: React.FC<MovingBannerProps> = ({ 
  text, 
  speed = 20, 
  backgroundColor = "bg-primary", 
  textColor = "text-white" 
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user is on a mobile device
    const checkMobile = () => {
      setIsMobile(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    // Show text immediately instead of waiting for animation
    setIsVisible(true);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  // Calculate animation duration in seconds - reduce time for faster appearance
  const animationDuration = `${speed}s`;

  return (
    <>
      {/* Add the animation styles to the document head */}
      <style dangerouslySetInnerHTML={{ __html: bannerAnimationStyle }} />
      
      <div 
        className={`overflow-hidden py-2 ${backgroundColor} transition-all duration-300 cursor-default ${isHovered && !isMobile ? 'shadow-lg bg-opacity-90' : ''}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{ position: 'relative' }}
      >
        <div 
          className={`whitespace-nowrap ${textColor} font-medium ${isVisible ? 'opacity-100' : 'opacity-0'}`}
          style={{
            display: 'inline-block',
            position: 'relative',
            animation: `scrollText ${animationDuration} linear infinite`,
            animationPlayState: (isHovered && !isMobile) ? 'paused' : 'running',
            animationDelay: '0s',
          }}
        >
          <span className="inline-block mr-8">{text}</span>
          <span className="inline-block mr-8">{text}</span>
          <span className="inline-block mr-8">{text}</span>
        </div>
      </div>
    </>
  );
};

export default MovingBanner; 